// Styles for AccountOverviewNotification go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledEmailUnsubscribe = styled.div`
  .unsubscribe {
    &__email {
      max-width: unset;
      @media ${baseVariables.mediaQuery.md} {
        max-width: ${toRem(343)};
      }
    }
    &__consents {
      .consent-bg {
        background-color: ${baseVariables.color['neutral20']};
        margin-left: auto;
      }

      &__container {
        &__hrLine {
          border-top: ${toRem(1)} ${baseVariables.color['neutral20']} solid;
          color: ${baseVariables.color['neutral20']} !important;
        }
        &__checkbox {
          &__labelText {
            position: relative;
            bottom: ${toRem(4)};
          }
          label {
            padding-left: ${toRem(24)} !important;
            margin-bottom: 0;
          }
        }
      }
    }
  }
  &__errormsg {
    p {
      margin-bottom: 0 !important;
    }
  }

  .modal-footer {
    &__unsubscribe {
      width: inherit;
      @media ${baseVariables.mediaQuery.md} {
        width: max-content;
      }
    }
  }
  .m-message-content {
    p {
      margin-bottom: 0 !important;
    }
  }

  .titleDescription {
    p {
      margin-bottom: 0 !important;
    }
  }

  .error-label {
    font-size: ${baseVariables.font.fontXs};
    color: ${baseVariables.color.alert50} !important;
  }
`;
